import { useSelector } from "react-redux"
import { AssessmentRM } from "models/RM"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { saveWordsFetch } from "store/middlewares/words.crud"
import { updateType } from 'keys'
import { useCallback } from "react"
import { markingWordsHooks } from ".."
import qc from "keys/queryClient"

const useSave = () => {
    const { words } = useSelector(state => state.words)
    const { assessment } = useSelector(state => state.assessment)

    const queryClient = useQueryClient()

    const isTraining = markingWordsHooks.useIsTraining()

    const { mutateAsync: saveWordsRQ, isPending: saveWordsLoading } = useMutation({ mutationFn: saveWordsFetch })

    const saveMarkingWords = useCallback(async () => {
        const nWords = await saveWordsRQ({ assessment, words, isTrainingAssessment: isTraining })
        queryClient.invalidateQueries({ queryKey: [qc.watingForMarkingCount] })

        const wordsWithoutUpdateTypeDelete = nWords.filter(word => word.update_type != updateType.delete)

        
        let data = new AssessmentRM({
            endPoint: assessment.endPoint,
            transcriptionStopPoint: assessment.transcriptionStopPoint,
            timePoint: assessment.timePoint,
            words: wordsWithoutUpdateTypeDelete,
            prosody: assessment.prosody,
            comments: assessment.comments
        })
        return data
    }, [assessment, words, isTraining])

    return {
        save: saveMarkingWords,
        loading: saveWordsLoading
    }
}

export default useSave